<template>
  <v-data-table class="elevation-1"
                :headers="headers"
                :items="items"
                :loading="progress('getAllClients')"
                hide-default-footer
                no-data-text="No available clients"
                :items-per-page="-1">
    <template v-slot:item="props">
      <Item :item="props.item"
            :availableReportSendModesByValue="availableReportSendModesByValue"
            :availableReportSendModes="availableReportSendModes"
            @click="handleItemClick">
      </Item>
    </template>
  </v-data-table>
</template>

<script>
import Item from './ClientItem'
import _ from 'lodash'

import {mapGetters, mapState} from 'vuex'

export default {
  name: 'List',
  props: {
    items: Array
  },
  components: {
    Item
  },
  data() {
    return {
      headers: [
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'title'
        },
        {
          text: 'Report email',
          align: 'left',
          sortable: false,
          value: 'reportEmail',
          width: '350px'
        },
        {
          text: 'Report send mode',
          align: 'left',
          sortable: false,
          value: 'reportSendMode'
        },
        {
          text: 'Due time',
          align: 'left',
          sortable: false,
          value: 'periodExecution'
        },
        {
          text: 'Contract number',
          align: 'left',
          sortable: false,
          value: 'contractNumber'
        }
      ]
    }
  },
  computed: {
    ...mapState('clients', {
      availableReportSendModes: state => state.availableReportSendModes,
    }),
    ...mapGetters('clients', {
      progress: 'progress'
    }),
    availableReportSendModesByValue() {
      return _.keyBy(this.availableReportSendModes, 'value')
    }
  },
  methods: {
    handleItemClick(item) {
      this.$emit('clientSelected', item.id)
    }
  }
}
</script>

<style scoped>

</style>